import React, { useState, useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { aisleByActiveByAreaBySortKey } from "../../../graphql/reloadyard/custom-queries";
import {
  inventoryItemByAisleByStatus,
  inventoryItemByLocationByStatus,
  locationByAreaBySortKey,
} from "../../../graphql/inventory/custom-queries";
import {
  Backdrop,
  Box,
  Button,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SpeedIcon from "@material-ui/icons/Speed";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import { Title, useNotify } from "react-admin";
import LocationCapacity from "../../../components/common/LocationCapacity";
import { XIcon } from "../../../components/common/iconography";
import CrewCard from "../../../components/common/CrewCard";
import { isAuthorized, logError } from "../../../utils/appUtils";
import { ForceTitle } from "../../../components/common/ForceTitle";
import {
  AclType,
  AreaType,
  InventoryStatus,
  LocationType,
  PortalType,
} from "../../../utils/constants";
import {
  getAisleFullName,
  getLocationFullName,
  isBulkArea,
} from "../../../utils/locationUtils";
import { StructuredAisle } from "./StructuredAisle";
import { LocationInventories } from "./LocationInventories";
import { useUser } from "../../../authenticatorApp/UserContext";
import { StructuredLocationDialog } from "../../../managerApp/resources/reloadYard/StructuredLocationDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  clearButton: {
    marginRight: theme.spacing(-2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
  list: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const YardUtilization = ({ match }) => {
  return (
    <>
      <Title title={<ForceTitle title="Utilization" />} />
      <Route
        path={`${match.path}/:id`}
        render={(props) => <StructuredAisle {...props} />}
      />
      <Route
        path={`${match.path}`}
        exact
        render={(props) => <Utilization {...props} />}
      />
    </>
  );
};

const capacityArray = ["Any", 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

const Utilization = ({ match }) => {
  const classes = useStyles();
  const portalType = localStorage.getItem("portalType");

  return portalType === PortalType.MANAGER ? (
    <div className={classes.root}>
      <UtilizationView classes={classes} match={match} />
    </div>
  ) : (
    <CrewCard
      title="Yard Utilization"
      showDivider={false}
      icon={<SpeedIcon fontSize="large" />}
    >
      <UtilizationView classes={classes} match={match} />
    </CrewCard>
  );
};

const UtilizationView = ({ classes, match }) => {
  const { appUser } = useUser();
  const [areas, setAreas] = useState(
    appUser.reloadYard.areas.items.filter(
      (itm) => itm.areaType !== AreaType.TRACK
    )
  );
  const [selectedArea, setSelectedArea] = useState(areas[0]);
  const [aisles, setAisles] = useState();
  const [locations, setLocations] = useState();
  const [areaUtilization, setAreaUtilization] = useState();
  const [searchResult, setSearchResult] = useState([]);
  const [term, setTerm] = useState("");
  const [capacitySearchTerm, setCapacitySearchTerm] = useState(
    capacityArray[0]
  );
  const [capacitySearchOperator, setCapacitySearchOperator] = useState("<=");
  const [loading, setLoading] = useState(false);
  const showTotalCapacity =
    areaUtilization && !term && capacitySearchTerm === "Any";

  useEffect(() => {
    return () => {
      setAreas([]);
      setAisles([]);
      setLocations([]);
      setSearchResult([]);
    };
  }, []);
  useEffect(() => {
    if (selectedArea) {
      debugger;
      getAreaUtilization(selectedArea);
    }
  }, [selectedArea]);

  useEffect(() => {
    if (loading) return;
    if (selectedArea && aisles) {
      debugger;
      selectedArea.areaType === AreaType.BULK
        ? setSearchResult(locations)
        : setSearchResult(aisles);
    }
  }, [aisles, locations, selectedArea, loading]);

  const getAreaUtilization = async (currentArea) => {
    debugger;
    setLoading(true);
    const response = await API.graphql(
      graphqlOperation(aisleByActiveByAreaBySortKey, {
        areaId: currentArea.id,
        activeSortKey: { beginsWith: { active: "true" } },
        limit: 500,
      })
    );
    const aisles = response.data.aisleByActiveByAreaBySortKey.items;
    if (currentArea.areaType === AreaType.BULK) {
      await getBulkAreaUtilization(currentArea, aisles);
    } else {
      await getNonBulkAreaUtilization(currentArea, aisles);
    }
    debugger;
    setLoading(false);
  };

  const getNonBulkAreaUtilization = async (area, aisles) => {
    aisles.forEach((aisle) => {
      if (aisle.type === LocationType.STRUCTURED) {
        const aisleUtilzation =
          aisle.locations.items.reduce(
            (total, itm) => (total += itm.capacityUsed ? itm.capacityUsed : 0),
            0
          ) / aisle.locations.items.length;
        aisle.capacityUsed = aisleUtilzation;
      }
    });
    setAisles(aisles);
    const areaUtilzation =
      aisles.reduce((total, itm) => {
        if (area.id === itm.areaId) {
          return (total += itm.capacityUsed ? itm.capacityUsed : 0);
        }
        return total;
      }, 0) / aisles.length;
    setAreaUtilization(areaUtilzation);
  };

  const getBulkAreaUtilization = async (area, aisles) => {
    debugger;
    const response = await API.graphql(
      graphqlOperation(locationByAreaBySortKey, {
        reloadYardId: window.appUser.reloadYardId,
        areaIdSortKey: { beginsWith: { areaId: area.id } },
      })
    );
    debugger;
    response.data.locationByAreaBySortKey.items.sort((a, b) => {
      if (a.aisle.sortKey !== b.aisle.sortKey)
        return a.aisle.sortKey - b.aisle.sortKey;
      return ("" + a.name).localeCompare("" + b.name);
    });
    const bulkLocations = response.data.locationByAreaBySortKey.items;
    setAisles(aisles);
    setLocations(bulkLocations);
  };

  const refreshFn = () => getAreaUtilization(selectedArea);

  const handleAreaChange = async (areaId) => {
    debugger;
    const area = areas.find((itm) => itm.id === areaId);
    setLoading(true);
    setSelectedArea(area);
    setTerm("");
    setCapacitySearchTerm(capacityArray[0]);
    setCapacitySearchOperator("<=");
  };

  const clear = () => {
    setTerm("");
    doSearch({ capacitySearchOperator, capacitySearchTerm });
  };

  const handleSearchTermChange = (value) => {
    setTerm(value);
    doSearch({ term: value, capacitySearchOperator, capacitySearchTerm });
  };

  const handleCapacitySearchTermChange = (value) => {
    value = value !== capacityArray[0] ? Number(value) : value;
    setCapacitySearchTerm(value);
    doSearch({ term, capacitySearchOperator, capacitySearchTerm: value });
  };

  const doSearch = ({ term, capacitySearchOperator, capacitySearchTerm }) => {
    debugger;
    let searchItems =
      selectedArea.areaType === AreaType.BULK ? locations : aisles;
    if (capacitySearchTerm !== capacityArray[0]) {
      searchItems = searchItems.filter((itm) => {
        if (selectedArea.AreaType === AreaType.BULK) {
          const percentage = (itm.capacityUsed / itm.totalCapacity) * 100;
          if (capacitySearchOperator === "<=")
            return percentage <= capacitySearchTerm;
          return percentage >= capacitySearchTerm;
        } else {
          if (capacitySearchOperator === "<=")
            return itm.capacityUsed <= capacitySearchTerm;
          return itm.capacityUsed >= capacitySearchTerm;
        }
      });
    }

    if (term) {
      const searchTerm = term.toLowerCase().replace(/-/g, "");
      searchItems = searchItems.filter((itm) => {
        let match;
        let name;
        debugger;
        if (selectedArea.areaType === AreaType.BULK) {
          if (itm.productName)
            match = match || itm.productName.toLowerCase().includes(searchTerm);
          name = itm.name ? itm.name : "" + itm.sortKey;
        } else if (itm.type === LocationType.STRUCTURED) {
          name = getAisleFullName(itm).replace(/-/g, "");
        } else {
          name = getAisleFullName(itm).replace(/-/g, "");
        }
        match = match || name.toLowerCase().includes(searchTerm);
        return match || itm.zone.name.toLowerCase().includes(searchTerm);
      });
    }
    setSearchResult(searchItems);
  };

  const handleCapacitySearchOperator = (value) => {
    setCapacitySearchOperator(value);
    doSearch({ term, capacitySearchTerm, capacitySearchOperator: value });
  };

  return (
    <>
      <Box ml={1} mr={1} pb={0.5}>
        <Grid container spacing={2}>
          {selectedArea && (
            <Grid item xs={12} md={6} lg={4} variant="outlined">
              <TextField
                id="area"
                label="Area"
                margin="dense"
                variant="outlined"
                select
                fullWidth
                value={selectedArea.id ? selectedArea.id : ""}
                onChange={(evt) => handleAreaChange(evt.target.value)}
              >
                {areas.map((itm) => (
                  <MenuItem key={itm.id} value={itm.id}>
                    {itm.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          <Grid item xs={12} md={6} lg={4} variant="outlined">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  select
                  id="capacityOperator"
                  name="capacityOperator"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={capacitySearchOperator}
                  onChange={(evt) =>
                    handleCapacitySearchOperator(evt.target.value)
                  }
                >
                  {["<=", ">="].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  select
                  id="capacitySearch"
                  name="capacitySearch"
                  label="Capacity Used"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={capacitySearchTerm}
                  onChange={(evt) =>
                    handleCapacitySearchTermChange(evt.target.value)
                  }
                >
                  {capacityArray.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg={4} variant="outlined">
            <TextField
              name="search"
              size="small"
              variant="outlined"
              margin="dense"
              value={term}
              placeholder={
                selectedArea?.areaType === AreaType.BULK
                  ? "Aisle/Zone/Product"
                  : "Aisle/Zone"
              }
              fullWidth
              onChange={(evt) => handleSearchTermChange(evt.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton disableRipple onClick={clear}>
                      <XIcon className={classes.clearButton} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <UtilizationResults
        match={match}
        classes={classes}
        showTotalCapacity={showTotalCapacity}
        selectedArea={selectedArea}
        refreshFn={refreshFn}
        areaUtilization={areaUtilization}
        loading={loading}
        data={searchResult}
      />
    </>
  );
};

const UtilizationResults = ({
  match,
  classes,
  loading,
  showTotalCapacity,
  selectedArea,
  refreshFn,
  areaUtilization,
  data,
}) => {
  const getUtilizationSlider = () => {
    if (!selectedArea) return null;
    if (selectedArea.areaType === AreaType.BULK) {
      return <Box m={1} />;
    }
    if (showTotalCapacity) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          pt={1}
          pb={2}
        >
          <LinearProgress
            color="secondary"
            variant="determinate"
            value={areaUtilization}
            style={{ minWidth: "90%" }}
          />
          &nbsp;{" "}
          {Number(areaUtilization || 0).toLocaleString("en-US", {
            maximumFractionDigits: 0,
          })}
          %
        </Box>
      );
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        ml={1}
        mr={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        pt={0.25}
      >
        {getUtilizationSlider()}
        <Grid container spacing={2}>
          {data.map((itm) => (
            <LocationCard
              key={itm.id}
              aisle={itm}
              match={match}
              selectedArea={selectedArea}
              refreshFn={() => refreshFn(selectedArea)}
              classes={classes}
            />
          ))}
        </Grid>
      </Box>
    </>
  );
};

export const LocationCard = ({
  aisle,
  refreshFn,
  match,
  selectedArea,
  classes,
}) => {
  const [inventoryItems, setInventoryItems] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openStructuredDialog, setOpenStructuredDialog] = useState(false);
  const [dialogLocation, setDialogLocation] = useState(null);

  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const history = useHistory();
  const notify = useNotify();

  const getAisleTypeText = () => {
    if (!aisle.locations) return "";

    if (selectedArea.areaType === AreaType.BULK) {
      return "Bulk";
    }
    if (aisle.type === LocationType.UNSTRUCTURED) {
      return `${
        aisle.type.toLowerCase()[0].toUpperCase() +
        aisle.type.toLowerCase().substring(1)
      }`;
    }
    const set = new Set();
    aisle.locations.items.forEach((itm) => set.add(itm.bay));
    const text = `
            ${
              aisle.type.toLowerCase()[0].toUpperCase() +
              aisle.type.toLowerCase().substring(1)
            },
            ${set.size} bays, ${aisle.levels} levels`;
    return text;
  };

  const goToLocations = () => {
    debugger;
    history.replace(match.path + "/" + aisle.id);
  };

  const getInventories = async () => {
    if (aisle.type === LocationType.STRUCTURED) return;
    try {
      debugger;
      setLoading(true);
      setOpen(true);
      let inventoryItemsList;
      if (isBulkArea(selectedArea)) {
        const results = await API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: aisle.id,
            status: { beginsWith: InventoryStatus.STORED },
          })
        );
        inventoryItemsList = results.data.inventoryItemByLocationByStatus.items;
      } else {
        const results = await API.graphql(
          graphqlOperation(inventoryItemByAisleByStatus, {
            aisleId: aisle.id,
            status: { beginsWith: InventoryStatus.STORED },
          })
        );
        inventoryItemsList = results.data.inventoryItemByAisleByStatus.items;
      }
      inventoryItemsList.sort((a, b) =>
        a.inventory.accountName.localeCompare(b.inventory.accountName)
      );
      setInventoryItems(inventoryItemsList);
      debugger;
    } catch (error) {
      logError("utilization:LocationCard:getInventories", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const isLocationCapacityDisabled = (aisle) => {
    if (selectedArea.areaType === AreaType.BULK) return true;
    if (aisle.type === LocationType.STRUCTURED) return true;
    return false;
  };

  const getCardContent = () => {
    if (isBulkArea(selectedArea)) return getBulkContent();
    return getNonBulkContent();
  };

  const getBulkContent = () => {
    return (
      <>
        <Grid item xs={3}>
          <Typography color="textSecondary" component="span" variant="body2">
            Zone:
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Box display="flex" alignItems="center">
            <FiberManualRecordIcon style={{ color: aisle.zone.color }} />
            <Typography color="textSecondary" component="span" variant="body2">
              {aisle.zone.name}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Typography color="textSecondary" component="span" variant="body2">
            Aisle:
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Box display="flex" alignItems="center">
            <Typography color="textSecondary" component="span" variant="body2">
              {aisle.aisle?.name}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Typography
            color="textSecondary"
            component="span"
            variant="body2"
            gutterBottom
          >
            Capacity:
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography
            color="textSecondary"
            component="span"
            variant="body2"
            gutterBottom
          >
            {Number(aisle.bulkCapacity || 0).toLocaleString()} {aisle.bulkUnits}
          </Typography>
        </Grid>
        {
          <>
            <Grid item xs={3}>
              <Typography
                color="textSecondary"
                component="span"
                variant="body2"
                gutterBottom
              >
                Product:
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography
                color="textSecondary"
                component="span"
                variant="body2"
                gutterBottom
              >
                {aisle.productId ? aisle.productName : "N/A"}
              </Typography>
            </Grid>
          </>
        }
      </>
    );
  };

  const getNonBulkContent = () => {
    return (
      <>
        <Grid item xs={3}>
          <Typography color="textSecondary" component="span" variant="body2">
            Area:
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography color="textSecondary" component="span" variant="body2">
            {aisle.area.name}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography color="textSecondary" component="span" variant="body2">
            Zone:
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Box display="flex" alignItems="center">
            <FiberManualRecordIcon style={{ color: aisle.zone.color }} />
            <Typography color="textSecondary" component="span" variant="body2">
              {aisle.zone.name}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Typography
            color="textSecondary"
            component="span"
            variant="body2"
            gutterBottom
          >
            Type:
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography
            color="textSecondary"
            component="span"
            variant="body2"
            gutterBottom
          >
            {getAisleTypeText()}
          </Typography>
        </Grid>
      </>
    );
  };

  const handleManageClick = () => {
    setDialogLocation(aisle);
    setOpenStructuredDialog(true);
  };

  const handleCloseEditLocationDialog = () => setOpenStructuredDialog(false);

  const getCardActions = () => {
    const isUnstructuredOrBulk =
      aisle.type === LocationType.UNSTRUCTURED ||
      selectedArea.areaType === AreaType.BULK;
    const showManageLocationButton =
      selectedArea.areaType === AreaType.BULK && isAuthorized(AclType.MY_YARD);
    if (!isUnstructuredOrBulk) {
      return (
        <Button type="submit" onClick={goToLocations} size="large">
          Open
        </Button>
      );
    }

    const renderInventoriesButton = (
      <Grid md={showManageLocationButton ? 6 : 12}>
        <Box display="flex" justifyContent="center">
          <Button type="submit" onClick={getInventories} size="large">
            Inventories
          </Button>
        </Box>
      </Grid>
    );

    const renderManageLocationButton = showManageLocationButton ? (
      <Grid md={6}>
        <Box display="flex" justifyContent="center">
          <Button type="submit" onClick={handleManageClick} size="large">
            Open
          </Button>
        </Box>
      </Grid>
    ) : null;

    return (
      <Grid container justifyContent="space-between">
        {renderInventoriesButton}
        {renderManageLocationButton}
      </Grid>
    );
  };

  const getLocationCapacity = () => {
    const disabled = isLocationCapacityDisabled(aisle);
    return (
      <Grid item xs={12}>
        <Box mt={2}>
          <LocationCapacity
            disabled={disabled}
            showName={false}
            aisle={aisle}
            refreshFn={refreshFn}
          />
        </Box>
      </Grid>
    );
  };

  const getLocationInventoriesDialogTitle = (aisle) => {
    if (aisle.type === LocationType.BULK) {
      return `${getLocationFullName(aisle)} Inventories`;
    }
    return `${getAisleFullName(aisle)} Inventories`;
  };

  const setupAisle = async () => {
    refreshFn();
    handleCloseEditLocationDialog();
  };

  return (
    <Grid item xs={12} md={6} lg={4} variant="outlined" key={aisle.id}>
      <Paper variant="outlined">
        <CardContent>
          <Typography variant="h6" component="span" gutterBottom>
            {isBulkArea(selectedArea)
              ? getLocationFullName(aisle)
              : getAisleFullName(aisle)}
          </Typography>
          <Box mt={2} mb={0}>
            <Grid container>
              {getCardContent()}
              {getLocationCapacity()}
            </Grid>
          </Box>
        </CardContent>
        <Box width="100%" display="flex" m={0} justifyContent={"center"}>
          {getCardActions()}
        </Box>
      </Paper>
      {openStructuredDialog && dialogLocation && (
        <StructuredLocationDialog
          location={dialogLocation}
          aisle={dialogLocation.aisle}
          classes={classes}
          open={openStructuredDialog}
          handleClose={handleCloseEditLocationDialog}
          setupAisle={setupAisle}
        />
      )}

      <Dialog
        open={open}
        scroll={"paper"}
        fullWidth
        maxWidth={isSmall ? "xl" : "md"}
        fullScreen={isSmall ? true : false}
      >
        <Box
          component="span"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          m={2}
        >
          <Typography variant="h6">
            {getLocationInventoriesDialogTitle(aisle)}
          </Typography>
          <CancelOutlinedIcon fontSize="large" onClick={() => setOpen(false)} />
        </Box>
        <DialogContent>
          {loading ? (
            <Box
              m={4}
              display="flex"
              alignContent="center"
              justifyContent="center"
            >
              <CircularProgress color="inherit" />
            </Box>
          ) : (
            <LocationInventories inventoryItems={inventoryItems} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};
